/* ---------------------------------------------------------------
   Kuno · Verneinte Fragen ("ohne …") · 04.09.2026
   Laedt nach kuno-rezepte.js, vor kuno-render.js.

   Vorher: "ohne Zucker" zeigte alle 75 Zuckerwerte, "ohne Nuesse"
   die Warengruppe Nuesse, alles andere die Rueckfrage. Diese Schicht
   liest zuerst, WAS verneint wird, und antwortet nach Datenlage.
   Geschuetztes (Sperrliste, Krankheit, Longevity, gesund, Umlenkung)
   wird vorher durchgereicht. Begruendung im Projektdokument.
   --------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.KUNO_OHNE) return;
  window.KUNO_OHNE = '2026-09-04';
  if (typeof classifyVoll !== 'function' || typeof PRODUKTE === 'undefined') return;

  var N = (typeof NAEHRWERT !== 'undefined') ? NAEHRWERT : {};

  /* Eine Normalisierungsstufe; \\b versagt an Komposita und Umlauten. */
  function flach(t) {
    return String(t == null ? '' : t).toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function zahl(v) {
    if (v == null) return null;
    var x = parseFloat(String(v).replace(',', '.').replace(/[^0-9.]/g, ''));
    return isNaN(x) ? null : x;
  }
  function komma(n) { return String(n).replace('.', ','); }
  function marke(s) { window.kunoNaehrSpalte = s || null; }   /* kuno-naehrwert.js liest sie */

  /* Das Wort des Kunden, mit Umlauten - bis auf ein paar Formen, die
     als Ueberschrift schief klaengen. */
  var ANZEIGE = { nuss: 'Nüsse', schalenfrucht: 'Schalenfrüchte', sulfit: 'Sulfite',
                  eier: 'Ei', lactose: 'Laktose', kuhmilch: 'Milch', erdnuss: 'Erdnüsse' };
  function rohWort(text) {
    var m = String(text == null ? '' : text).toLowerCase()
      .match(/(?:ohne|kein|keine|keinen|frei von)\s+([a-zäöüß0-9-]+)/);
    var w = m ? m[1] : '';
    if (!w) {
      var f = String(text || '').toLowerCase().match(/([a-zäöüß]{3,})frei/);
      w = f ? f[1] : '';
    }
    if (!w) return '';
    if (ANZEIGE[w]) return ANZEIGE[w];
    return w.charAt(0).toUpperCase() + w.slice(1);
  }

  /* ---- Was verneint wird -------------------------------------- */

  var THEMA = [
    ['zuckerzusatz', 'zuckerzusatz zuckerzusaetze suessstoff suessstoffe suessungsmittel'],
    ['zucker', 'zucker'],
    ['salz', 'salz natrium kochsalz'],
    ['koffein', 'koffein coffein teein thein'],
    ['allergen', 'nuss nuesse schalenfrucht schalenfruechte mandel mandeln haselnuss ' +
      'haselnuesse walnuss walnuesse cashew cashews cashewkerne pistazie pistazien ' +
      'pekannuss pekannuesse macadamia erdnuss erdnuesse gluten weizen dinkel gerste ' +
      'roggen hafer getreide laktose lactose milch milcheiweiss kuhmilch molke soja ' +
      'sojalecithin ei eier huehnerei sesam sellerie senf fisch krebstiere schalentiere ' +
      'weichtiere lupine sulfit sulfite schwefel schwefeldioxid histamin allergen allergene'],
    ['zusatz', 'zusatzstoff zusatzstoffe zusatz zusaetze konservierungsstoff ' +
      'konservierungsstoffe aroma aromen aromastoffe emulgator emulgatoren farbstoff ' +
      'farbstoffe geschmacksverstaerker palmoel palmfett stabilisator verdickungsmittel ' +
      'gentechnik gvo']
  ];

  /* "ohne zugesetzten Zucker" ist eine andere Frage als "ohne Zucker". */
  var FUELL = ' zugesetzten zugesetzter zugesetztes zugesetzte zugesetztem zusaetzlichen ' +
    'zusaetzliche kuenstliche kuenstlichen raffinierten raffinierter raffiniertes ' +
    'industriellen weissen weisser viel viele jeden jede jedes ';
  /* Was nach "ohne" stehen kann, ohne dass eine Zutat gemeint ist. */
  var KEIN_STOFF = ' grund umwege umschweife wenn aber ende zweifel risiko probleme mich ' +
    'dich uns ihn das die der den dem ein eine einen mir dir weiteres ';

  function inListe(liste, wort) { return liste.indexOf(' ' + wort + ' ') >= 0; }

  function themaZu(kand) {
    for (var i = 0; i < THEMA.length; i++) {
      if ((' ' + THEMA[i][1] + ' ').indexOf(' ' + kand + ' ') >= 0) return THEMA[i][0];
    }
    return '';
  }

  /* "ohne X" | "kein X" | "frei von X" - und "Xfrei", aber nur bei
     bekanntem Stoff, sonst faengt sich jedes "versandkostenfrei" ein. */
  function verneinung(text) {
    var s = flach(text);
    var m = s.match(/(?:^| )(?:ohne|kein|keine|keinen|keinem|keines|frei von)( .+)$/);
    if (m) {
      var toks = m[1].split(' ').filter(Boolean), zugesetzt = false;
      while (toks.length && inListe(FUELL, toks[0])) {
        if (toks[0].indexOf('zugesetzt') === 0) zugesetzt = true;
        toks.shift();
      }
      if (!toks.length || inListe(KEIN_STOFF, toks[0])) return null;
      var paar = toks.slice(0, 2).join(' ');
      var id = themaZu(paar), wort = paar;
      if (!id) { id = themaZu(toks[0]); wort = toks[0]; }
      if (id === 'zucker' && zugesetzt) id = 'zuckerzusatz';
      return { id: id, wort: wort, satz: s };
    }
    var f = s.match(/(?:^| )([a-z]{3,})frei[a-z]{0,2}(?: |$)/);
    if (f) {
      var id2 = themaZu(f[1]);
      if (id2) return { id: id2, wort: f[1], satz: s };
    }
    return null;
  }

  /* ---- Warengruppe in derselben Frage -------------------------- */

  var GRUPPE = [
    ['honig', 'honig honige bluetenhonig'], ['oel', 'oel oele olivenoel olivenoele wuerzoel'],
    ['oliven', 'olive oliven'], ['essig', 'essig essige balsamico aceto'],
    ['schinken', 'schinken iberico jamon paleta lomo'], ['nuss', 'nuss nuesse'],
    ['saat', 'saat saaten samen koerner'], ['trockenfrucht', 'trockenfrucht trockenfruechte dattel datteln'],
    ['schoko', 'schokolade schokoladen schoko kakao'], ['riegel', 'riegel'],
    ['nussmus', 'nussmus mus creme cremes mandelcreme'], ['tomate', 'tomate tomaten'],
    ['suesses', 'fruchtgummi fruchtgummis pralinen konfekt suessigkeiten'],
    ['tee', 'tee tees gruentee schwarztee kraeutertee'], ['matcha', 'matcha']
  ];
  var GNAME = {
    honig: 'Honig', oel: 'Olivenöl', oliven: 'Oliven', essig: 'Essig', schinken: 'Schinken',
    nuss: 'Nüsse', saat: 'Saaten', trockenfrucht: 'Trockenfrüchte', schoko: 'Schokolade',
    riegel: 'Riegel', nussmus: 'Nussmus', tomate: 'Tomaten', suesses: 'Süßes', tee: 'Tee',
    matcha: 'Matcha'
  };

  /* Nur ausserhalb des verneinten Stoffs - sonst setzte "ohne Nuesse"
     die Gruppe Nuesse. */
  function gruppeIn(satz, stoffwort) {
    var rest = (' ' + satz + ' ').replace(' ' + stoffwort + ' ', ' ');
    for (var i = 0; i < GRUPPE.length; i++) {
      var w = GRUPPE[i][1].split(' ');
      for (var j = 0; j < w.length; j++) if (rest.indexOf(' ' + w[j] + ' ') >= 0) return GRUPPE[i][0];
    }
    return '';
  }

  /* ---- Datenauszuege ------------------------------------------- */

  function mitZucker() {
    return PRODUKTE.filter(function (p) { return N[p.s] && zahl(N[p.s].zucker) != null; });
  }
  function nachZucker(l) {
    return l.slice().sort(function (a, b) { return zahl(N[a.s].zucker) - zahl(N[b.s].zucker); });
  }
  function tee(mit) {
    return PRODUKTE.filter(function (p) {
      return (p.k === 'tee' || p.k === 'matcha') && (mit ? !!p.koffein : !p.koffein);
    });
  }

  /* ---- Die Antworten ------------------------------------------- */

  var Q_ZAHL = 'Nährwertangaben der Erzeuger vom Etikett · Grenze für „zuckerfrei“ nach ' +
    'Verordnung (EG) Nr. 1924/2006, Anhang';

  function zuckerOhne(gruppe) {
    var alle = mitZucker();
    var basis = gruppe ? alle.filter(function (p) { return p.k === gruppe; }) : alle;
    var treffer = nachZucker(basis.filter(function (p) { return zahl(N[p.s].zucker) <= 0.5; }));
    var gn = GNAME[gruppe] || '';

    if (!treffer.length) {
      /* Statt leerer Seite die Gruppe vom niedrigsten Wert an. */
      var nah = nachZucker(basis);
      if (!nah.length) return null;
      return {
        eyebrow: 'Ohne Zucker',
        summary: 'Du suchst etwas ohne Zucker. Die Zahl stammt vom Etikett, geschätzt wird nichts.',
        tags: ['ohne Zucker', gn || 'alle Warengruppen', nah.length + ' Artikel'],
        title: (gn ? gn + ': ' : '') + 'kein Artikel bleibt unter 0,5 g Zucker je 100 g',
        intro: 'Ab 0,5 g je 100 g darf ein Lebensmittel nicht mehr „zuckerfrei“ heißen. ' +
          'Hier steht deshalb die Reihenfolge vom niedrigsten Wert an, jede Zahl vom Etikett.',
        visual: 'help', refine: false,
        metrics: [[komma(zahl(N[nah[0].s].zucker)) + ' g', 'niedrigster Wert'],
                  [String(nah.length), 'Artikel mit Angabe'], ['Etikett', 'Herkunft der Zahl']],
        source: Q_ZAHL,
        pick: function () { marke('zucker'); return nah; }
      };
    }
    return {
      eyebrow: 'Ohne Zucker',
      summary: 'Du suchst etwas ohne Zucker. Gezählt wird der Wert vom Etikett.',
      tags: ['ohne Zucker', 'höchstens 0,5 g je 100 g', treffer.length + ' Artikel'],
      title: (gn ? gn + ': ' : '') + treffer.length + ' Artikel mit höchstens 0,5 g Zucker je 100 g',
      intro: 'Bis zu dieser Grenze darf ein Lebensmittel „zuckerfrei“ heißen. Geprüft an ' +
        alle.length + ' Artikeln mit hinterlegter Nährwerttabelle — wo keine Angabe vorliegt, ' +
        'steht der Artikel nicht in der Liste.',
      visual: 'nuts', refine: true,
      metrics: [[String(treffer.length), 'Artikel'], ['0,5 g', 'Grenze je 100 g'],
                [String(alle.length), 'Artikel mit Angabe']],
      choice: [
        { title: 'Ohne zugesetzten Zucker', desc: 'Der Unterschied zum Gesamtzucker.', ask: 'ohne Zuckerzusatz' },
        { title: 'Zucker je 100 g', desc: 'Alle Werte, vom niedrigsten an.', ask: 'Zucker je 100 g' }
      ],
      source: Q_ZAHL,
      pick: function () { marke('zucker'); return treffer; }
    };
  }

  function zuckerzusatz() {
    return {
      eyebrow: 'Ohne Zuckerzusatz',
      summary: 'Du willst wissen, ob nachgesüßt wurde. Das steht nicht in der Nährwerttabelle.',
      tags: ['Zuckerzusatz', 'Zutatenliste', 'Etikett'],
      title: 'Ob Zucker zugesetzt wurde, zeigt nur die Zutatenliste',
      intro: 'Die Nährwerttabelle nennt den gesamten Zucker — auch den, der von Natur aus in ' +
        'Frucht, Honig oder Milch steckt. Ob zusätzlich gesüßt wurde, steht allein in der ' +
        'Zutatenliste. Sie liegt auf jeder Produktseite offen.',
      visual: 'help', refine: false, noProduct: true,
      metrics: [['Zutatenliste', 'entscheidet'], ['Nährwerttabelle', 'zeigt den Gesamtzucker'],
                ['1 Zutat', 'lässt sich nicht süßen']],
      choice: [
        { title: 'Artikel mit einer einzigen Zutat', desc: 'Kurze Liste, nichts zugesetzt.', ask: 'Artikel mit wenigen Zutaten' },
        { title: 'Höchstens 0,5 g Zucker je 100 g', desc: 'Geprüft an der Nährwerttabelle.', ask: 'zuckerfrei' }
      ],
      source: 'Zutatenliste und Nährwertangaben vom Etikett des Erzeugers'
    };
  }

  function koffein() {
    var liste = tee(false), mit = tee(true).length;
    if (!liste.length) return null;
    return {
      eyebrow: 'Ohne Koffein',
      summary: 'Du suchst einen Aufguss ohne Koffein — für abends oder den ganzen Tag.',
      tags: ['ohne Koffein', 'Kräuter', 'Früchte'],
      title: liste.length + ' Tees ohne Koffein',
      intro: 'Kräuter- und Früchtetees enthalten von Natur aus kein Koffein. Grün-, Schwarz- ' +
        'und Matchatee dagegen schon — diese ' + mit + ' Sorten stehen nicht in der Liste.',
      visual: 'nuts', refine: true,
      metrics: [[String(liste.length), 'ohne Koffein'], [String(mit), 'mit Koffein'],
                ['Erzeuger', 'Herkunft der Angabe']],
      source: 'Sortenangabe des Erzeugers je Tee',
      pick: function () { marke(null); return liste; }
    };
  }

  function allergen(text) {
    var w = rohWort(text) || 'Allergene';
    return {
      eyebrow: 'Allergene',
      summary: 'Du willst ' + w + ' vermeiden. Verbindlich ist dafür das Etikett auf der Packung.',
      tags: [w, 'Zutatenliste', 'Spuren'],
      title: w + ': Zutaten und Spuren stehen auf jeder Produktseite',
      intro: 'Unter der Zutatenliste steht der Allergenhinweis — und darunter, ob Spuren möglich ' +
        'sind. Beides gehört zusammen, und beides kann eine gefilterte Liste nicht ersetzen. ' +
        'Bei einer Allergie zählt allein das Etikett auf der Packung.',
      visual: 'help', refine: false, noProduct: true,
      metrics: [['Zutatenliste', 'auf jeder Produktseite'], ['Spuren', 'stehen im Allergenhinweis'],
                ['Etikett', 'gilt im Zweifel']],
      choice: [
        { title: 'Artikel mit einer einzigen Zutat', desc: 'Kürzeste Zutatenliste im Sortiment.', ask: 'Artikel mit wenigen Zutaten' },
        { title: 'Nach einem einzelnen Artikel fragen', desc: 'Dann steht die Zutatenliste daneben.', ask: 'Bio Walnusskerne von Keimling' }
      ],
      source: 'Zutatenliste und Allergenhinweis des Erzeugers, LMIV (EU) Nr. 1169/2011'
    };
  }

  function unbekannt(text) {
    var w = rohWort(text) || 'diesen Stoff';
    return {
      eyebrow: 'Ohne …',
      summary: 'Du willst ' + w + ' vermeiden. Belegt ist das hier nicht.',
      tags: [w, 'keine Angabe', 'Zutatenliste'],
      title: 'Zu „ohne ' + w + '“ liegt keine geprüfte Angabe vor',
      intro: 'Kuno nennt nur, was belegt ist — für ' + w + ' fehlt dieser Beleg. Die vollständige ' +
        'Zutatenliste steht auf jeder Produktseite und beantwortet die Frage in einem Blick. ' +
        'Geprüft nennen lassen sich Zucker, Salz und Koffein.',
      visual: 'help', refine: false, noProduct: true,
      metrics: [['Zucker', 'geprüft je 100 g'], ['Salz', 'geprüft je 100 g'], ['Koffein', 'je Teesorte']],
      choice: [
        { title: 'Höchstens 0,5 g Zucker je 100 g', desc: 'Geprüft an der Nährwerttabelle.', ask: 'zuckerfrei' },
        { title: 'Ohne zugesetztes Salz', desc: 'Geprüft an der Nährwerttabelle.', ask: 'ohne Salz' },
        { title: 'Artikel mit einer einzigen Zutat', desc: 'Kurze Liste, nichts zugesetzt.', ask: 'Artikel mit wenigen Zutaten' }
      ],
      source: 'Zutatenliste des Erzeugers auf der jeweiligen Produktseite'
    };
  }

  /* ---- Einhaengen ---------------------------------------------- */

  var SCHUTZ = ['blocked', 'krankheit', 'longevity', 'gesund'];
  function geschuetzt(r) {
    if (typeof results === 'undefined') return false;
    for (var i = 0; i < SCHUTZ.length; i++) if (results[SCHUTZ[i]] && r === results[SCHUTZ[i]]) return true;
    return false;
  }
  function istGeneric(r) {
    if (typeof results !== 'undefined' && r === results.generic) return true;
    return !!(r && r.noProduct && String(r.title || '').indexOf('Was ist dir wichtiger') === 0);
  }

  var alt = classifyVoll;

  classifyVoll = function (text) {
    var r = alt(text);
    if (!r || r.redirect || geschuetzt(r)) return r;

    var v = verneinung(text);
    if (!v) return r;

    var neu = null;
    if (v.id === 'zucker') neu = zuckerOhne(gruppeIn(v.satz, v.wort));
    else if (v.id === 'zuckerzusatz') neu = zuckerzusatz();
    else if (v.id === 'salz') neu = alt('ohne Salz');   /* results.salt ist der Mengenrechner */
    else if (v.id === 'koffein') neu = koffein();
    else if (v.id === 'allergen') neu = allergen(text);
    else if (v.id === 'zusatz') neu = (typeof results !== 'undefined' && results.ingredients) || null;
    else if (istGeneric(r)) neu = unbekannt(text);   /* nur die Rueckfrage abfangen */

    return neu || r;
  };
})();
